import React, { createContext, useContext, useState } from 'react';

const FormContext = createContext();

const initialFormData = {
  method: 'upload', 
  contact: { firstName: '', lastName: '', email: '' },
  upload: { workbook: null, supportingFiles: [] },
  form: {
    transactions: [{ 
      id: Date.now(), 
      date: '', 
      customer: '', 
      product: '', 
      amount: '', 
      currency: 'GBP', // Updated default for UK/EU context
      channel: '', 
      notes: '',
      supportingFiles: [] 
    }],
    annualSpend: Array.from({ length: 12 }, (_, i) => ({ year: 2014 + i, spend: '', category: '' })),
    assets: [{ id: Date.now(), name: '', dateAcquired: '', cost: '', supplier: '', isNew: 'yes', notes: '' }],
    lifecycle: [{ id: Date.now(), name: '', usefulLife: '', replacementDate: '', maintFreq: '', maintCost: '', notes: '' }],
    purchaseMix: { new: '', repeat: '', subscription: '', oneOff: '' },
    distribution: Array.from({ length: 12 }, (_, i) => ({ year: 2014 + i, percentage: '' })),
    qualitative: {
      replacementFreq: '', triggers: '', maintReqs: '', maintResp: '', schedules: '',
      marketContext: '', behavior: '', pricing: '', supplierIssues: '', other: ''
    }
  },
  isSubmitted: false,
  submitAttempted: false 
};

export const FormProvider = ({ children }) => {
  const [data, setData] = useState(initialFormData);

  const updateData = (section, field, value) => {
    setData(prev => ({
      ...prev,
      [section]: field ? { ...prev[section], [field]: value } : value
    }));
  };

  const updateFormSection = (section, value) => {
    setData(prev => ({
      ...prev,
      form: { ...prev.form, [section]: value }
    }));
  };

  const setSubmitAttempted = (val) => {
    setData(prev => ({ ...prev, submitAttempted: val }));
  };

  const submitForm = () => {
    setData(prev => ({ ...prev, isSubmitted: true }));
  };

  const resetForm = () => {
    setData({ ...initialFormData, isSubmitted: false, submitAttempted: false });
  };

  return (
    <FormContext.Provider value={{ data, updateData, updateFormSection, submitForm, setSubmitAttempted, resetForm }}>
      {children}
    </FormContext.Provider>
  );
};

export const useFormContext = () => useContext(FormContext);